// extracted by mini-css-extract-plugin
export default {"wrapper":"style-module--wrapper--a4a09"};